import { buildFaqPageSchema, looksLikeFaq } from '@core-mkt/services/schema/faq-schema.util';
import type { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import type { Accordion } from './accordion';

interface AccordionSchema {
  itemTitle?: unknown;
  itemDescription?: unknown;
}

/**
 * Returns a FAQPage schema node for an accordion when its items look like Q&A
 * (≥80% of titles end in `?` or start with a question word). Returns null
 * otherwise — non-FAQ accordions emit no schema to avoid the spam-classifier
 * risk Google added with the 2023 FAQ tightening.
 */
export function getAccordionSchema(data: Accordion | null | undefined, pageUrl: string): SchemaOrgNode | null {
  const items = (data?.accordionItems as AccordionSchema[] | undefined) ?? [];
  if (items.length === 0) return null;

  const titles = items.map((item) => item?.itemTitle);
  if (!looksLikeFaq(titles)) return null;

  return buildFaqPageSchema({
    '@id': `${pageUrl}#accordion-faq`,
    questions: items.map((item) => ({
      question: item?.itemTitle,
      answer: item?.itemDescription,
    })),
  });
}
